import type { CaseImageMeta, CaseImageWithUrl, PaginatedImagesResult } from "@/types/case";

import type { APIInstance } from "./apiService";

export class CaseImagesService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async getImages(caseId: string): Promise<CaseImageMeta[]> {
    const response = await this.api.get<{ images: CaseImageMeta[] }>(`/cases/${caseId}/images`);
    return response.data?.images ?? [];
  }

  async getImagesWithSignedUrls(
    caseId: string,
    page: number,
    limit = 50
  ): Promise<PaginatedImagesResult> {
    const { data } = await this.api.get<{
      items: CaseImageWithUrl[];
      page: number;
      limit: number;
      total: number;
      has_more: boolean;
    }>(`/cases/${caseId}/images`, {
      params: { with_signed_url: true, page, limit },
    });
    return {
      items: data?.items ?? [],
      page: data?.page ?? page,
      limit: data?.limit ?? limit,
      total: data?.total ?? 0,
      hasMore: data?.has_more ?? false,
    };
  }
}
